import {Component, Input, OnInit} from '@angular/core';
import {KnockoutFieldModel} from "../../knockout-field/knockout-field.model";
import {FieldService} from "../../../services/field/field.service";
import {RequestService} from "../../../services/request/request.service";
import {SystemJournalWhatsappConfigModel} from "./system-journal-whatsapp.config.model";
import {SystemJournalWhatsappSendMessageRequestModel} from "./system-journal-whatsapp.send-message-request.model";
import {AlertService} from "../../../services/alert/alert.service";
import {UtilService} from "../../../services/util/util.service";
import { $translate } from 'src/app/core/services/internationalization/localize.service';

@Component({
  selector: 'sb-system-journal-whatsapp',
  templateUrl: './system-journal-whatsapp.component.html',
  styleUrls: ['./system-journal-whatsapp.component.scss']
})
export class SystemJournalWhatsappComponent implements OnInit {
  private recordId: string;
  private recordTable: string;
  private messageConfig: SystemJournalWhatsappConfigModel;
  errors: string[] = []
  private record: any;
  private recordField: any;

  @Input()
  set context(context: any) {
    this.isOpenDialogButtonHidden = context.isNewRecord;

    this.recordId = context.recordId;
    this.recordTable = context.recordTable;
    this.messageConfig = context.root.whatsAppConfig;
    this.record = context.record;
    this.recordField = context.root.relatedRecordField;
  }

  showDialog: boolean;
  isDialogVisible: boolean;
  isSendMessageDisabled: boolean = true;
  isOpenDialogButtonHidden: boolean;

  //TODO: This is way toooo slow to display !!!!
  userRecipientsMultipleReferenceField: KnockoutFieldModel;

  openDialogButtonTitle = $translate("ng.component.whatsapp-message-dialog.open-button-title")`Send a WhatsApp Message`;
  newDialogTitle = $translate("ng.component.whatsapp-message-dialog.new-dialog-title")`Send a WhatsApp Message`;
  userRecipientsLabel = $translate("ng.component.whatsapp-message-dialog.user-recipients-label")`To`;
  discardButtonLabel = $translate("ng.component.whatsapp-message-dialog.discard-button-label")`Discard`;
  sendMessageLabel = $translate("ng.component.whatsapp-message-dialog.send-message-label")`Send`;
  messageLabel = $translate("ng.component.whatsapp-message-dialog.message-label")`Message`;
  messageSuccess = $translate("ng.component.whatsapp-message-dialog.message-success")`Message sent successfully`;
  errorsLabel = $translate("ng.component.whatsapp-message-dialog.errors-label")`Errors`;
  defaultErrorMessage = $translate("ng.component.whatsapp-message-dialog.default-error-message")`Failed to Send message`;

  private userRecipients: string[] = [];
  message: string;

  constructor(
    private fieldService: FieldService,
    private requestService: RequestService,
    private alertService: AlertService,
    private utilService: UtilService) {
  }

  ngOnInit(): void {
  }

  show() {
    // TODO: Field can be slow to show ....
    if (!this.userRecipientsMultipleReferenceField) {
      this.initUserRecipientsField();
    }

    var div = document.createElement('div');
    div.innerHTML = this.record[this.recordField].value()
    this.message = this.utilService.extractTextFromHtml(this.record[this.recordField].value())

    this.showDialog = true;
    this.isDialogVisible = true;
  }

  newDialogButtonSelect($event: MouseEvent) {
    this.show();
  }

  onDialogClose() {
    this.showDialog = false;
  }


  private clearDialogInputs() {
    this.userRecipientsMultipleReferenceField.data = {
      answer: {value: ""}
    };
    this.message = "";
    this.errors = []
  }

  private initUserRecipientsField() {
    // TODO Fetch default user recipients values from Outbound notification record
    this.userRecipientsMultipleReferenceField = this.fieldService.createMultiReferenceField(
      'User',
      this.userRecipientsLabel,
      'User',
      {
        valueChangeCallback: value => this.onUserRecipientsChange(value),
        rendererProperties: {

          additionalFilterQuery: {
            operator: "and", value: [
              {fieldName: "Mobile", operator: "isnotempty"},
              {operator: "=", field: "Active", value:true}
            ]
          },
          "dropdown.displayFields": "Name:4,Mobile:4,Email:4"
        }
      });
  }

  close() {
    this.isDialogVisible = false;
  }

  async sendMessage() {
    if (this.messageConfig.controller) {
      await this.sendViaBusinessController();
    } else {
      await this.sendViaServicelyCoreController()
    }
  }

  onmessageChange(message: string) {
    this.isSendMessageEnabled()
  }

  private isSendMessageEnabled() {
    this.isSendMessageDisabled = !this.message || this.message.trim().length == 0 || this.userRecipients.length == 0
  }

  private onUserRecipientsChange(value: string) {
    this.userRecipients = value?.split(',') || [];
    this.isSendMessageEnabled();
  }

  private showErrors(errors: string[]) {
    if (this.isDialogVisible) {
      this.errors = errors
    } else {
      this.alertService.errorMessage(errors.reduce((acc, err) => acc + err + '\n', ''));
    }
  }

  private async sendViaBusinessController() {
    const requestOptions = {
      _recipients: this.userRecipients.map(userId => {return { userId: userId }}),
      _recordId: this.recordId,
      _recordTable: this.recordTable,
      _recordField: this.recordField,
      _message: this.message
    };

    try {
      const response = await (window as any).WS.controller(this.messageConfig.controller, requestOptions);

      if (response?.data?.hasErrors) {
        this.showErrors(response.data.errors)
      } else {
        this.showDialog = false;
        this.alertService.success(this.messageSuccess);
      }
    } catch (e) {
      this.showErrors([e.message || this.defaultErrorMessage])
    }
  }

  private async sendViaServicelyCoreController() {
    const request = {
      provider: {id: this.messageConfig.providerId, type: 'whatsapp'},
      content: {
        type: 'template',
        templateId: this.messageConfig.templateId,
        message: this.message,
        templateDataScript: this.messageConfig.templateDataScript
      },
      recipients: this.userRecipients.map(userId => {
        return { userId: userId }}),
      relatedRecord: `${this.recordId}:${this.recordTable}`,
    } as SystemJournalWhatsappSendMessageRequestModel

    try {
      const response: any = await this.requestService.createRequest()
        .controller("servicely.core.Message")
        .method("sendMessage")
        .data(request)
        .execute()

      if ((response?.data?.errors || []).length > 0) {
       this.showErrors(response.data.errors)
      } else {
        this.showDialog = false;
        this.alertService.success(this.messageSuccess);

        this.record[this.recordField].value(this.message);
      }
    } catch (e) {
      this.showErrors([e.message || this.defaultErrorMessage])
    }
  }
}
